<script setup lang="ts">
import type {
  ExternalCourse,
  ExternalSubject,
  PublicFormVerificationStatus,
} from '@/models/current-student-advanced-standing-form/api'
import PreviousSubjectsExternalSubjectsDisplay from '@/components/current-student-advanced-standing-form/previous-subjects/PreviousSubjectsExternalSubjectsDisplay.vue'
import type { LegacyClassBinding } from '@/components/current-student-advanced-standing-form/shared/types'

defineProps<{
  externalCourses: ExternalCourse[]
  coursesWithSubjects: ExternalCourse[]
  emptyExternalSubjectsMessage: (course: ExternalCourse) => string
  rowClass: (subject: ExternalSubject) => LegacyClassBinding
  isVerifiedStatus: (status: PublicFormVerificationStatus) => boolean
  canEditExternalSubject: (subject: ExternalSubject) => boolean
  canAddExternalSubject: (course: ExternalCourse) => boolean
}>()

const emit = defineEmits<{
  editSubject: [subject: ExternalSubject, course: ExternalCourse]
  addSubject: [course: ExternalCourse]
}>()
</script>

<template>
  <fieldset>
    <legend>Previous Subjects</legend>
    <p>
      For each of the courses listed below, please add the <b>completed</b> subjects for which you would like to seek credit for.
    </p>
    <p>
      Subjects marked as 'Verified' has been confirmed as valid by the university.
      If there is an error with any of these subjects, please contact <a href="https://latrobe-current.custhelp.com/app/home" target="_blank" rel="noreferrer">ASK La Trobe.</a>
    </p>
    <PreviousSubjectsExternalSubjectsDisplay
      :external-courses="externalCourses"
      :courses-with-subjects="coursesWithSubjects"
      :empty-external-subjects-message="emptyExternalSubjectsMessage"
      :row-class="rowClass"
      :is-verified-status="isVerifiedStatus"
      :can-edit-external-subject="canEditExternalSubject"
      :can-add-external-subject="canAddExternalSubject"
      @edit-subject="(subject, course) => emit('editSubject', subject, course)"
      @add-subject="emit('addSubject', $event)"
    />
  </fieldset>
</template>
